module.exports = __webpack_public_path__ + "156b4fe3679ac2a73204ffd987174980.png";